module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Ywh2we/image/cover.jpg?1708094060643",
      "alt": "This image is the cover for the book Letters from Rosie"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Letters from Rosie\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Rosie had been a weekly visitor to the residents of the local retirement home for some years before her visits were brought to an abrupt halt by the COVID-19 lockdown in March 2020. She missed the visits, as did the residents, so I decided that Rosie should become a virtual visitor instead. Each week, ‘she’ emailed a letter with a photo detailing some event that had happened in her life the previous week, and these were printed and distributed within the home. They were a great success and were enjoyed by the residents, some of whom had never met Rosie and only knew her from her letters. They continued for more than two years. Now here they are for you to read and enjoy.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tony Anderson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Tony departed his native New Zealand in 1964, working his way to the UK for a holiday. The ‘holiday’ lasted 26 years, during which time he served in the Royal Air Force as a pilot and later joined a civil airline. He and his wife, Maureen, have been living in Western Australia since 1993. He retired from flying in 2001 and has since spent his leisure time tending his small vineyard and repairing watches and clocks.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0